<template>
  <wc-dialog
    :title='title'
    :showDialog='showDialog'
    :icon='$store.state.icons.modules.chartOfAccounts.icon'
    hideCancel
    saveText='Close'
    @save="$emit('close')"
    width='1200'
  >
    <template v-slot:dialog-form v-if='transactions.length > 0'>
      <transactions-table v-if='transactions.length > 0' :transactions='transactions' :hide-checkbox='true'></transactions-table>
    </template>
    <div v-if='loading'>
      <wc-loading line msg='Loading transactions'></wc-loading>
    </div>
    <div v-if='transactions.length == 0'>
      No transactions found.
    </div>
  </wc-dialog>
</template>

<script>
import TransactionsTable from './TransactionsTable'

export default {
  name: 'account-transaction-dialog',
  props: {
    showDialog: {
      required: true
    },
    transactions: {
      required: true
    },
    title: {
      required: true
    },
    loading: {
      required: true
    }
  },
  data: () => ({
    loadingTransactions: true
  }),
  components: {
    'transactions-table': TransactionsTable
  }
}
</script>
